var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.maskUrl && _vm.showMask)?_c('img',{staticClass:"inpainting-mask-image",style:({
		...(_vm.width && { width: _vm.width }),
		...(_vm.height && { height: _vm.height }),
	}),attrs:{"src":_vm.maskUrl}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }